import { axiosInstanceVirtualCard } from "../axios";
import {
  IssuerConfigCreate,
  IssuerConfigCreations,
  RequestResponse
} from "../types";

export const getIssuerConfig = async (id: number): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceVirtualCard.get(
      `/api/v1/issuer-configs/${id}`
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to fetch issuer config: Internal server error");
      return {
        error: true,
        message: "Unable to fetch issuer config: Internal server error",
        data: null
      };
    }
    console.error("Unable to fetch issuer config: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: null
    };
  }
};

export const getIssuerConfigs: (
  pageNumber: number,
  pageSize: number,
  issuerCode?: string,
  name?: string
) => Promise<
  RequestResponse<{ records: IssuerConfigCreations[]; total: number }>
> = async (pageNumber, pageSize, issuerCode, name) => {
  try {
    let searchQuery = "";
    if (issuerCode) {
      searchQuery = `${issuerCode}`;
    } else if (name) {
      searchQuery = `${name}`;
    }

    const response = await axiosInstanceVirtualCard.get(
      "/api/v1/issuer-configs",
      {
        params: {
          page_num: pageNumber,
          page_size: pageSize,
          search_query: searchQuery
        }
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data.content,
        total: response.data.data.count
      }
    };
  } catch (err: any) {
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to fetch issuer configs: Internal server error");
      return {
        error: true,
        message: "Unable to fetch issuer configs: Internal server error",
        data: null
      };
    }
    console.error("Unable to fetch issuer configs: ", { err });
    return {
      error: true,
      message: err.response.data?.message || err.message || err,
      data: null
    };
  }
};

export const deleteIssuerConfig = async (
  id: number
): Promise<RequestResponse> => {
  try {
    await axiosInstanceVirtualCard.delete(`/api/v1/issuer-configs/${id}`);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to delete issuer config: ", err);
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to delete issuer config: Internal server error");
      return {
        error: true,
        message: "Unable to delete issuer config: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const updateIssuerConfig = async (
  id: number,
  payload: IssuerConfigCreate
): Promise<RequestResponse> => {
  try {
    const updatedPayload = {
      id,
      ...payload
    };
    await axiosInstanceVirtualCard.put(
      `/api/v1/issuer-configs/${id}`,
      updatedPayload
    );
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to update issuer config: ", err);
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to update issuer config: Internal server error");
      return {
        error: true,
        message: "Unable to update issuer config: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const createIssuerConfig = async (
  payload: IssuerConfigCreate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceVirtualCard.post(`/api/v1/issuer-configs`, payload);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to create issuer config: ", err);

    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to create issuer config: Internal server error");
      return {
        error: true,
        message: "Unable to create issuer config: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};
